// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"210770dc","498":"ee55549d","703":"fa6598a0"}[chunkId] + ".chunk.js";
};